import { bool, func, string } from 'prop-types'

import Flag from 'views/components/atoms/Flag'
import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import ButtonAsLink from 'views/components/molecules/ButtonAsLink'
import ModalShowButton from 'views/components/molecules/ModalShowButton'

const ProductLabelAbo = ({
  label,
  displayAboLabel,
  handleProductAboLabelClick,
}) => (
  <li
    data-clientside-hook="productLabelAbo"
    className="o-ProductLabel-Abo l-flex l-flex__primary u-vertical-align--top u-margin-small--bottom u-margin-small--right o-ProductLabels__ProductLabelContainer"
    aria-hidden={!displayAboLabel ? true : null}
  >
    <ModalShowButton
      component={ButtonAsLink}
      modalId="aboModal"
      onClick={handleProductAboLabelClick}
      name="productLabelAbo"
    >
      <Flag label={label} abo>
        <span className="u-padding-x-small--left l-flex o-ProductLabels__icon-wrapper">
          <IconCircleInfo size="x-small" />
        </span>
      </Flag>
    </ModalShowButton>
  </li>
)

ProductLabelAbo.propTypes = {
  label: string.isRequired,
  displayAboLabel: bool,
  handleProductAboLabelClick: func,
}
ProductLabelAbo.defaultProps = {
  displayAboLabel: false,
  handleProductAboLabelClick: null,
}

export default ProductLabelAbo
